<template>
  <div>
    <loader v-if="settProfile === undefined" />
    <div
      v-if="settProfile !== undefined"
      :class="[$style.card]"
    >
      <div
        v-if="fieldType('enabled')"
        :class="$style.settContainer"
        @click="check('enabled')"
      >
        <div :class="$style.label">
          {{ $t('settings.trackComputerActivity') }}
        </div>
        <toggle-button
          v-model="result.enabled"
          :class="$style.toggle"
          :value="result.enabled"
          :sync="true"
          @click.native.prevent
        />
      </div>

      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.countIdleTimeNoActivityMore') }}</label>
        <div :class="$style.inline">
          <input
            v-model.number="result.IdleTime"
            type="number"
            :class="$style.input"
            :disabled="!result.enabled"
            @change="change('IdleTime')"
          >
          {{ $t('global.min') }}
        </div>
      </div>
    </div>

    <div
      v-if="settProfile !== undefined"
      :class="[$style.card]"
    >
      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.productivityProfile') }}</label>
        <div class="agentsSelect profile">
          <vue-select
            v-model="currentProdProfile"
            :options="profiles"
            label="name"
            :reduce="(option) => option.id"
            :clearable="false"
            :searchable="false"
            :class="$style.select"
            @input="changeCurrentProdProfile"
          >
            <!-- eslint-disable-next-line vue/no-unused-vars  -->
            <template #no-options="{ search, searching, loading }">
              {{ $t('settings.noProfilesToSelect') }}
            </template>
          </vue-select>
        </div>
        <button
          :class="$style.button"
          @click="openModal('prof')"
        >
          {{ $t('settings.manageProductivityProfiles') }}
        </button>
      </div>
    </div>

    <div
      v-if="settProfile !== undefined"
      :class="[$style.card]"
    >
      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.workTimeSchedule') }}</label>
        <div class="agentsSelect profile">
          <vue-select
            v-model="currentWtProfile"
            :options="wtProfiles"
            label="name"
            :reduce="(option) => option.id"
            :clearable="false"
            :searchable="false"
            :class="$style.select"
            @input="changeCurrentWtProfile"
          >
            <!-- eslint-disable-next-line vue/no-unused-vars  -->
            <template #no-options="{ search, searching, loading }">
              {{ $t('settings.noProfilesToSelect') }}
            </template>
          </vue-select>
        </div>
        <button
          :class="$style.button"
          @click="openModal('wt')"
        >
          {{ $t('settings.manageWorkTimeSchedules') }}
        </button>
      </div>
    </div>
    <div
      v-if="settProfile !== undefined"
      :class="[$style.card]"
    >
      <div>
        <div :class="$style.vacationContainer">
          <label :class="$style.label">
            {{ $t('settings.vacationSchedule') }}
            <span v-if="!vacations.length">{{ $t('settings.noVacations') }}</span>
          </label>
          <button
            :class="$style.button"
            @click="openModal('addVacationModal')"
          >
            {{ $t('settings.addVacation') }}
          </button>
        </div>
        <div v-if="vacations">
          <div
            v-for="(vacation, index) of vacations"
            :key="index"
            :class="$style.vacationContainer"
            @mouseover="showDeleteButton(index)"
            @mouseleave="hideDeleteButton(index)"
          >
            <div :class="$style.container">
              <div>{{ $t('global.from') }} {{ vacation.startTime }}</div>
              <div>{{ $t('global.to') }} {{ vacation.endTime }}</div>
              <img
                v-show="hoveredIndex === index"
                :title="$t('global.delete')"
                src="@/assets/images/icons/navigation/trash.svg"
                :class="$style.buttonVacation"
                @click="openDeleteModal(vacation)"
              >
            </div>
          </div>
        </div>
      </div>
      <button
        :class="[$style.button, $style.meetButton]"
        @click="openModal('viewMeetingsModal')"
      >
        {{ $t('settings.meetingsAndConferences') }}
      </button>
    </div>
    <prod-prof-modal
      id="prof"
      :class="$style.modal"
      :profiles="profiles"
      @close="closeModal('prof')"
      @update="getProductiveProfile()"
    />
    <wt-modal
      id="wt"
      :class="$style.modal"
      :profiles="wtProfiles"
      @close="closeModal('wt')"
      @update="getWtProfile()"
    />
    <add-vacation-modal
      id="addVacationModal"
      :class="$style.modal"
      :contact-id="contactId"
      @close="closeModal('addVacationModal')"
      @add="handleAddVacation"
    />
    <delete-user-modal
      id="deleteVacation"
      :class="$style.addModalDelete"
      :selected="selected"
      type="vacation"
      @close="closeDeleteModal()"
      @update="removeVacation()"
    />
    <view-meetings-modal
      id="viewMeetingsModal"
      :class="$style.modal"
      @close="closeModal('viewMeetingsModal')"
    />
  </div>
</template>

<script>
  import { ToggleButton } from 'vue-js-toggle-button';
  import Vue from 'vue';
  import VueSelect from 'vue-select';
  import { getIdleSettings, getProdProfile, getWtProfile, getLinksContact } from '@/api/methods/settings';
  import ProdProfModal from '@/views/settings/agents/agent/settings/prod-prof-modal.vue';
  import WtModal from '@/views/settings/agents/agent/settings/wt-modal.vue';
  import AddVacationModal from '@/views/settings/agents/agent/settings/add-vacation-modal.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import DeleteUserModal from '@/views/settings/agents/modals/deleteModal.vue';
  import ViewMeetingsModal from './view-meetings-modal.vue';

  Vue.component('ToggleButton', ToggleButton);

  export default {
    components: {
      ProdProfModal,
      VueSelect,
      Loader,
      WtModal,
      AddVacationModal,
      DeleteUserModal,
      ViewMeetingsModal,
    },
    data: () => ({
      result: {},
      profiles: [],
      prodProfile: undefined,
      wtProfiles: [],
      wtProfile: undefined,
      currentProdProfile: undefined,
      currentWtProfile: undefined,
      vacations: [],
      contactId: null,
      hoveredIndex: null,
      selected: null,
    }),
    computed: {
      selectedComputer() {
        return {
          type: this.$route.params.type,
          id: this.$route.params.computer,
        };
      },
      settProfile() {
        return this.$store.getters['settings/profile'];
      },
    },
    async created() {
      const { type, computer, compName, userName } = this.$route.params;
      if (type === 'computer') {
        await this.getLinksContact(computer, compName, userName);
      }
      await this.getSettings();
      await this.getProductiveProfile();
      await this.getWtProfile();
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/cancel') {
            await this.getSettings();
            this.currentProdProfile = this.prodProfile;
            this.currentWtProfile = this.wtProfile;
          }
        },
      });
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/paramChanged') {
            await this.getSettings();
            await this.getProductiveProfile();
            await this.getWtProfile();
          }
        },
      });
    },
    methods: {
      showDeleteButton(day) {
        this.hoveredIndex = day;
      },
      hideDeleteButton() {
        this.hoveredIndex = null;
      },
      async sortVacationsByStartTime() {
        this.vacations.sort((a, b) => {
          const dateA = this.parseDate(a.startTime);
          const dateB = this.parseDate(b.startTime);
          return dateA.getTime() - dateB.getTime();
        });
      },
      parseDate(dateString) {
        const [day, month, year] = dateString.split('.').map(Number);
        return new Date(year, month - 1, day);
      },
      async handleAddVacation(id, startTime, endTime) {
        const { contactId } = this;
        const newVacation = {
          id,
          contactId,
          startTime,
          endTime,
        };
        this.vacations.push(newVacation);
        await this.sortVacationsByStartTime();
      },
      openDeleteModal(vacation) {
        this.selected = vacation;
        document.getElementById('deleteVacation').style.display = 'flex';
      },
      closeDeleteModal() {
        document.getElementById('deleteVacation').style.display = 'none';
      },
      removeVacation() {
        this.vacations = this.vacations.filter((item) => item.id !== this.selected.id);
      },
      async getLinksContact(id, compName, name) {
        const { result } = await getLinksContact(id, compName, name);
        this.vacations = result.vacations;
        this.contactId = result.contactId;
      },
      async getWtProfile() {
        if (this.settProfile) {
          const result = await getWtProfile(this.settProfile);
          if (result.result) {
            this.wtProfiles = result.result.profiles;
            this.wtProfile = result.result.selected;
            const current = this.$store.getters['settings/wtProfile'];
            if (current) this.currentWtProfile = current;
            else this.currentWtProfile = this.wtProfile;
          }
        }
      },
      changeCurrentProdProfile(val) {
        if (val) {
          this.$store.commit('settings/setProdProfile', val);
        }
      },
      changeCurrentWtProfile(val) {
        if (val) {
          this.$store.commit('settings/setWtProfile', val);
        }
      },
      async getProductiveProfile() {
        if (this.settProfile) {
          const result = await getProdProfile(this.settProfile);
          if (result.result) {
            this.profiles = result.result.profiles;
            this.prodProfile = result.result.selected;
            const current = this.$store.getters['settings/prodProfile'];
            if (current) this.currentProdProfile = current;
            else this.currentProdProfile = this.prodProfile;
          }
        }
      },
      closeModal(id) {
        document.getElementById(id).style.display = 'none';
      },
      openModal(id) {
        document.getElementById(id).style.display = 'flex';
      },
      change(field) {
        this.$store.commit('settings/addIdleSettings', {
          key: field,
          value: this.result[field],
        });
      },
      check(key) {
        this.$set(this.result, key, !this.result[key]);
        this.$store.commit('settings/addIdleSettings', {
          key,
          value: this.result[key],
        });
      },
      fieldType(field) {
        return typeof this.result[field] !== 'undefined';
      },
      async getSettings() {
        this.result = {};
        let type = 0;
        if (this.selectedComputer.id) {
          if (this.selectedComputer.type === 'folder') type = 2;

          this.promise = await getIdleSettings(this.selectedComputer.id, type).then(({ data }) => {
            if (data) {
              this.result = data.result;
            }
          });
          const settings = this.$store.getters['settings/idleSettings'];
          if (settings) {
            Object.entries(settings).forEach(([key, value]) => {
              this.result[key] = value;
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .settContainer {
    display: flex;
    padding: 10px 0px;
    margin: 0px 10px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: $light-gray;
    }
  }
  .vacationContainer {
    display: flex;
    padding: 10px 0px;
    margin: 0px 10px;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background: $light-gray;
    }
  }

  .container {
    display: flex;
    gap: 6px;
    height: 18px;
    margin-left: 10px;
    align-items: center;
    font-size: 14px;
  }
  .buttonVacation {
    margin-left: 5px;
    cursor: pointer;
  }

  .addModalDelete {
    display: none;
    z-index: 5;
  }

  .label {
    margin: 0px 10px;
    font-size: 14px;
  }

  .input {
    margin-right: 5px;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
    width: 90px;
  }

  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
    min-height: 96px;
    > :not(:last-child) {
      border-bottom: 0.2px solid #eee;
    }
  }

  .disabled,
  .disabled * {
    cursor: default;
  }

  .modal {
    display: none;
    z-index: 3000;
  }

  .select {
    margin: 15px;
    z-index: 0;
  }

  .button {
    margin: 5px;
    //height: 36px;
    cursor: pointer;
    width: 190px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    @media (max-width: 1770px) {
      height: 50px;
    }
  }

  .meetButton {
    height: 36px;
  }
  .toggle {
    z-index: 0;
  }
  .inline {
    display: inline-flex;
    align-items: center;
  }
</style>

<style>
  .profile {
    width: 50%;
  }
</style>
